import { render, staticRenderFns } from "./PaginaImportSoggettiAnagrafica.vue?vue&type=template&id=4abe4310"
import script from "./PaginaImportSoggettiAnagrafica.vue?vue&type=script&lang=js"
export * from "./PaginaImportSoggettiAnagrafica.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportSoggettiAnagrafica.vue?vue&type=style&index=0&id=4abe4310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports